import React from 'react';
import { IconButton } from '@mui/material';
import HelpPopover from '../../../HelpPopover';
import type { ListRowCell } from './ListRow';

export function iconButtonCell(opts: {
  xs?: number;
  ariaLabel: string;
  description?: string;
  descriptionId?: string;
  onClick: () => void;
  Icon: React.ElementType;
  disabled?: boolean;
}): ListRowCell {
  const { xs, ariaLabel, description, descriptionId, onClick, Icon, disabled } = opts;
  const button = (
    <IconButton aria-label={ariaLabel} size="small" onClick={onClick} disabled={disabled}>
      <Icon fontSize="small" />
    </IconButton>
  );

  return {
    xs,
    align: 'center',
    columnWidth: 'icon',
    wrapTypography: false,
    content: description ? (
      <HelpPopover id={descriptionId ?? `${ariaLabel}-description`} text={description} ariaLabel={ariaLabel}>
        {button}
      </HelpPopover>
    ) : (
      button
    ),
  };
}
